import { FormattedMessage as FM } from "react-intl";

import Text from "componentsv2/form/Text";
import CheckboxField from "componentsv2/form/Checkbox";

const ExtraFields = (props) => {
  const {
    cradle,
    description_cradle,
    transfer,
    description_transfer,
    pet,
    description_pet,
    label_verification,
  } = props;

  return (
    <aside className="w-full mb-4">
      <div className="rounded-md bg-white">
        <div className="bg-neutral-900 w-full flex justify-between py-3 px-3  mt-3 font-medium">
          <div className="text-gray-50">
            <FM id="app.webcheckin.extra_fields" />
          </div>
        </div>
        <div className="flex flex-col divide-y divide-gray-300 space-y-2 py-2 overflow-y-auto max-h-max">
          <div className="px-2 pb-2">
            <CheckboxField
              styleLabel="!mt-0"
              name="cradle_form"
              label="hotel.folio.guest.cradle"
              data={cradle}
              required={true}
            />
            {cradle.value && (
              <FM id="app.webcheckin.placeholder.description">
                {() => (
                  <Text
                    style="h-12!"
                    name="description_cradle"
                    placeholder="¿Cómo la necesitas?"
                    data={description_cradle}
                    field={{ required: true }}
                  />
                )}
              </FM>
            )}
          </div>
          <div className="px-2 pb-2">
            <CheckboxField
              name="transfer_form"
              styleLabel="!mt-0"
              label="hotel.folio.guest.transfer"
              data={transfer}
              required={true}
            />
            {transfer.value && (
              <FM id="app.webcheckin.placeholder.description">
                {() => (
                  <Text
                    style="h-12!"
                    name="description_transfer"
                    placeholder="¿A que horas te recojemos y donde?"
                    data={description_transfer}
                    field={{ required: true }}
                  />
                )}
              </FM>
            )}
          </div>
          <div className="px-2">
            <CheckboxField
              name="pet_form"
              styleLabel="!mt-0"
              label="hotel.folio.guest.pet"
              data={pet}
              required={true}
            />
            {pet.value && (
              <FM id="app.webcheckin.placeholder.description">
                {() => (
                  <Text
                    style="h-12!"
                    name="description_pet"
                    placeholder="¿Qué tipo de mascota es?"
                    data={description_pet}
                    field={{ required: true }}
                  />
                )}
              </FM>
            )}
          </div>
          <div className="px-2 text-sm text-center p-3">
            <FM id="hotel.folio.guest.validation" />
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ExtraFields;
